import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="asz52k13em53">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="frtl5e7odwli">
          🎁 Plus, you’ll get these 5 bonus resources
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-19" data-mp="5wrwejhbawjg">
          Premium complementary resources included with your purchase of The Autonomous Child
          Visual System™ — at no extra cost.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t2smspnl4ipl">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-21" data-mp="1marsfjd1e21f" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} cover`} width={1024} height={1536} loading="lazy" className="mt-10 aspect-[2/3] w-20 shrink-0 self-start overflow-hidden rounded-xl border border-grape/15 object-cover shadow-[0_10px_18px_-6px_rgba(7,35,26,0.3)] sm:w-24" data-id="element-22" data-mp="3n552it5idm4q" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="2uik9lo9dx1z2">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="38giiie4xs676">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="33gns0bp2pimn">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="noggn9jmbjuk" /> Bonus {b.n}
                  </span>
                  <span className="text-sm font-bold" data-id="element-27" data-mp="iqexypq3tmjm">
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="3cj6geb28jmns">{b.price}</span>{' '}
                    <span className="text-blush-deep" data-id="element-29" data-mp="3hhzm3hba69de">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-30" data-mp="3ljun0kpaukqn">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-31" data-mp="3lhrxe1s26tmg">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-32" data-mp="2tt81bb00stan">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-33" data-mp="2xrnslr34wntv">
            💰 Total bonus value: <span className="text-plum/50 line-through" data-id="element-34" data-mp="32r0jcmx4mf1q">$157</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-35" data-mp="37lefirjm4q7g">
              TODAY FREE WITH THE AUTONOMOUS CHILD VISUAL SYSTEM™
            </span>
          </p>
        </div>
      </div>
    </section>;
}